import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';
import ContextStates from '../context/ContextStates';
import { motion } from 'framer-motion';
import SideCompra from '../components/sideCompra';
import { useParams } from 'react-router-dom'
import { Url } from '../components/Url';
import { areaAnimateLR, areaAnimateS } from '../components/Animations'


const Producto = () => {
	const [productoV, setProductoV] = useState({});
	const [cantidad, setCantidad] = useState(1)
	const [agregado, setAgregado] = useState(false)
	const [imgCentral, setImgCentral] = useState('')
	const { producto, setProducto, setProductoAux, productos, setProductos, subProductos, setSubProductos, venta, setVenta, setFormView, setViewOpen, modify } = useContext(ContextStates);
	let prodParam = useParams()


	useEffect(() => {
		const getProductos = async () => {
			const formData = new FormData()
			formData.append('id', 1);
			try {
				const results = await axios({
					url: Url + 'api/listadoproductos.php',
					method: 'POST',
					data: formData,
				})
				//console.log("llegando", results)
				setProductos(results.data.results);
			} catch (e) {
				console.log(e)
			}
		}
		getProductos()
	}, [modify])

	useEffect(() => {
		if (productos.length > 0) {
			productos.forEach(element => {
				if (element.id === prodParam.id) {
					let aux = element
					aux.cantidad = cantidad
					console.log(element.codigo)
					setProductoV(aux)
					setImgCentral(aux.imagenes[0].imagen)
					setProductoAux(aux)
				}
			});
		}
	}, [productos])

	useEffect(() => {
		if (typeof productoV!=='undefined') {
			let aux = productoV;
			if (cantidad === '')
				aux.cantidad = 1;
			else
				aux.cantidad = cantidad;
			setProductoV(aux)

		}
	}, [cantidad])

	useEffect(() => {
		const addProducto = async () => {
			if (typeof producto !== 'undefined' && producto.id === productoV.id) {
				if (producto.codigo) {
					const auxVenta = JSON.stringify(venta)
					const formData = new FormData()
					formData.append('venta', auxVenta);
					formData.append('producto', JSON.stringify(producto));

					try {
						const response = await axios({
							url: Url + 'api/addProducto.php',
							'Content-Type': 'application/json',
							method: 'POST',
							data: formData,
							dataType: 'JSON',
						})
						console.log("agregado ", response)
						setVenta(response.data.results);
						localStorage.removeItem('localVenta');
						localStorage.setItem('localVenta', JSON.stringify(response.data.results))
						setAgregado(true)
						setProducto({})

						setCantidad(1)
						setSubProductos([])
					} catch (e) {
						console.log(e)
					}
				}
			}
		}
		addProducto()
	}, [producto])

	const handleAdd = () => {
		setProducto(productoV)
	}

	return (
		<Layout
			pagina={"Producto"}
		>
			<div className='w-full pt-10 pb-20'>
				<div className='md:w-9/12 w-full mx-auto sm:flex shadow-xl rounded-xl'>
					<div className='w-full p-1 sm:w-2/3 mt-5 sm:mb-10'>
						<motion.h3
							className="text-center text-2xl font-semibold uppercase"
							initial={"offscreen"}
							whileInView={"onscreen"}
							viewport={{ once: true, amount: 0.1 }}
							variants={areaAnimateLR}
						>{productoV.descripcion}</motion.h3>
						{typeof productoV.imagenes !== 'undefined' && productoV.imagenes.length > 0 && (
							<div className='w-full p-10'>
								<motion.img
									className="mx-auto md:h-96 mt-5 object-cover rounded" src={Url + imgCentral}
									initial={"offscreen"}
									whileInView={"onscreen"}
									viewport={{ once: true, amount: 0.1 }}
									variants={areaAnimateLR}
								/>
							</div>
						)}
						<motion.p
							className="text-center text-xl" initial={"offscreen"}
							whileInView={"onscreen"}
							viewport={{ once: true, amount: 0.1 }}
							variants={areaAnimateLR}
						>{productoV.descripcionext}</motion.p>
						<div className='w-full flex'>
							{typeof productoV.imagenes !== 'undefined' && productoV.imagenes.map((item, index) => (
								<div key={index} className='w-1/4 sm:w-1/6 p-2'>
									<button
										type='button'
										onClick={() => setImgCentral(item.imagen)}
									>
										<motion.img
											className="object-cover rounded" src={Url + item.imagen} 
											whileInView={"onscreen"}
											viewport={{ once: true, amount: 0.1 }}
											variants={areaAnimateLR}
										/>
									</button>
								</div>
							))}
						</div>
					</div>
					<div className='w-full sm:w-1/3 mt-2 sm:mt-10 mb-10'>
						{!agregado ? (
							<>
								<p className='text-center mt-5 mb-10 text-md'>{productoV.descripcionext}</p>
								<p className='text-center text-2xl font-semibold'>$ {parseFloat(productoV.precio).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
								<div className='w-full p-5'>
									<div className='w-1/2 mx-auto'>
										<label htmlFor='cantidad' className='text-xl uppercase text-gray-600'>Cantidad</label>
										<input
											type='number'
											id='cantidad'
											className='p-3 w-full rounded bg-white border border-gray-300'
											value={cantidad}
											onChange={(e) => setCantidad(e.target.value)}
										/>
									</div>
								</div>
								<div className="w-1/10 sm:items-start px-5 pt-4">
									<button
										type="button"
										className="w-full shadow-md p-3 bg-blue-600 text-gray-100 hover:bg-blue-500 hover:cursor-pointer transition-all uppercase font-semibold rounded mt-1"
										onClick={() => handleAdd()}
									>
										Agregar
									</button>

								</div>
							</>
						) : (
							<SideCompra />
						)}

					</div>
				</div>

			</div>
		</Layout>
	)
}

export default Producto